import React, { Component } from 'react';
//import { MDBContainer, MDBIframe } from "mdbreact";
import {
    MDBInput, toast, ToastContainer, MDBBtnFixedItem, MDBCard, MDBCardTitle, MDBCardText, MDBFormInline, MDBBadge,
    MDBContainer, MDBListGroup, MDBListGroupItem, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter
} from 'mdbreact';
import DataLayer from '../Utilities/DataLayer';
import Header from './ComponentFragments/Header';

class Media extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mediaList: []
        }
        this.props.loaderOff();
        this.viewMedia = this.viewMedia.bind(this);
        this.getMediaData = this.getMediaData.bind(this);
    }

    componentWillMount() {
        this.getMediaData();

    }

    viewMedia = (item) => {
        const { history } = this.props;
        history.push({
            pathname: '/salesforce/mediaview',
            state: {
                mediaId: item.mediaId,
                folder: item.folder,
                extension: item.extension
            }
        })
    }

    componentDidUpdate(prevProps) {
        var prevParams = prevProps.match.params.categoryId;
        var currParams = this.props.match.params.categoryId;
        if (prevParams !== currParams) {
            this.getMediaData();
        }
    }

    async getMediaData() {
        this.props.loaderOn();
        var dl = new DataLayer();
        let MediaResponse = await dl.Get("/common/getmediaitems/" + this.props.match.params.categoryId);
        this.setState({
            mediaList: MediaResponse.data
            
        });

        this.props.loaderOff();


    }

    render() {
        let header = "Media (" + this.props.getRouteParam() + ")"
        return (
            <div>
                <Header headerText={header}
                    hideSearch='true'
                />
                <MDBRow>
                    {
                        this.state.mediaList.map((item) => {
                            let url = "https://tupp.tuppafrica.co.za/" + item.folder + "/" + item.mediaId + "." + item.extension
                            return (
                                <MDBCol xl="3" lg="4" md="6" sm="12" className="mb-r" >
                                    <MDBCard className="card-body" style={{ marginTop: "1rem" }}>
                                        <MDBCardTitle><h5>{item.title}</h5></MDBCardTitle>
                                        <MDBCardText>
                                            {item.description}
                                        </MDBCardText>
                                        <hr className="hr_grey" />
                                        <div className="flex-row text-center" >
                                            <MDBBtn rounded color="purple" size="sm" onClick={() => this.viewMedia(item)}>View Media</MDBBtn>
                                            
                                        </div>
                                        <div className="flex-row text-center" >
                                            <a href={url} target="_blank">Download Media</a>
                                        </div>
                                    </MDBCard>
                                </MDBCol>
                            )

                        })
                    }
                </MDBRow>
            </div>    
        )
    }
    //return (
    //    <MDBContainer className="text-center">
    //        <MDBIframe src="http://sista-test.tupperwaresa.co.za/media/vid-20200316-wa0011.mp4" />
    //    </MDBContainer>
    //);
}

export default Media;